import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import LotInfoFormLayout from './LotInfoFormLayout';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from "devextreme-react/toolbar";
import {CommentLayout } from "./Layout";

function CommentTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleReset = () => {
    if(props.selectedDetails)
        props.setformFields(prevFields => ({
            ...prevFields,
            COMMENT: props.selectedDetails.comment,
            USERDEFINEDCOMMENT: props.selectedDetails.userDefinedComment,
        }));
    };

    const handleFieldChange = useCallback((name, value, e) => {
    }, []);
    const handlePrimaryFormLoad = useCallback(() => {
        if(props.isCommittedTransaction){
            if (formRefs.current) {
                Object.keys(formRefs.current).forEach((key) => {
                    //if (key === "REFERENCE" || key === "COMMENT") return;
                    const instance = formRefs.current[key]?.instance;
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                });
            }
        }
    }, []);


    return (

        <div id="accordion" style={{ height: "100%", overflow: "auto" }}>
                <Toolbar className="header">
                    <Item location="after">
                        <Button
                            text="Save"
                            onClick={props.handleFormSubmit}
                            type="default"
                            className="accordianButton"
                            disabled={props.isCommittedTransaction == true}
                        />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                    </Item>
                </Toolbar>
                <div className="AccordionItemBody">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='865ED990-4F75-4418-9ABB-5DAEEFC8106A'
                        layoutName='WMTransactionDetailsCommForm'
                        defaultFormSchema={CommentLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handlePrimaryFormLoad}
                    />
                </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(CommentTab);